import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withRights } from '../../../../providers/RightsConsumer';
import { TableContainer, Table, TableBody, TableCell, TableRow, Grid } from '@mui/material';
import { Button } from '@totalsoft/rocket-ui';
import { Prompt } from 'react-router-dom';
import { RightsContext } from 'providers/RightsContext';
import OfferDecisionSubsequentConditionItem from './OfferDecisionSubsequentConditionItem';
import { BoldTableHead } from 'components/common/CommonStyles';

const OfferDecisionSubsequentConditionList = ({ subsequentConditions, onSave, onPropertyChange, saving, t, rights }) => {
  const { isImage } = useContext(RightsContext);

  return (
    <Grid container spacing={1}>
      <Prompt when={subsequentConditions.some(x => x.dirtyInfo.isDirty)} message={() => t('LeavingWithoutSaving')} />
      <TableContainer>
        <Table>
          <BoldTableHead>
            <TableRow>
              <TableCell>{t('OfferEdit.Decision.SubsequentCondition.Active')}</TableCell>
              <TableCell>{t('OfferEdit.Decision.SubsequentCondition.Code')}</TableCell>
              <TableCell>{t('OfferEdit.Decision.SubsequentCondition.Text')}</TableCell>
              <TableCell>{t('OfferEdit.Decision.SubsequentCondition.User')}</TableCell>
              <TableCell>{t('OfferEdit.Decision.SubsequentCondition.DueDate')}</TableCell>
              <TableCell>{t('OfferEdit.Decision.SubsequentCondition.ActivationDate')}</TableCell>
              <TableCell>{t('OfferEdit.Decision.SubsequentCondition.Done')}</TableCell>
              <TableCell>{t('OfferEdit.Decision.SubsequentCondition.Comment')}</TableCell>
            </TableRow>
          </BoldTableHead>
          <TableBody>
            {subsequentConditions.map(({ document, dirtyInfo }, idx) => {
              return (
                <OfferDecisionSubsequentConditionItem
                  key={idx}
                  condition={document}
                  onPropertyChange={onPropertyChange(idx)}
                  isDirty={dirtyInfo.isDirty}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {!isImage && (
        <Grid item mt={2}>
          <Button
            color='primary'
            onClick={onSave}
            disabled={
              rights.readOnlyFull ||
              saving ||
              !subsequentConditions.some(x => x.dirtyInfo.isDirty) ||
              !rights.decisionSubsequentConditionsWrite
            }
          >
            {saving ? t('Saving') : t('Save')}
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

OfferDecisionSubsequentConditionList.propTypes = {
  subsequentConditions: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired
};

export default withTranslation()(withRights(OfferDecisionSubsequentConditionList));
